module.exports = __webpack_public_path__ + "img/80.1c1659d8.png";